import { jsx as o } from "react/jsx-runtime";
import { ModalCloseButton as e } from "@chakra-ui/react";
import { Icon as i } from "../icon/icon.js";
import { Icons as r } from "../icon/types.js";
import { ThemeSpaceVariable as t, ThemeIconSizeVariable as m } from "../../theme/theme-types.js";
function c({ isAbsolutePositioned: n = !1 }) {
  return n ? /* @__PURE__ */ o(
    e,
    {
      position: "absolute",
      zIndex: 1,
      top: t.Medium,
      right: t.Medium,
      children: /* @__PURE__ */ o(i, { icon: r.Close, size: m.Medium })
    }
  ) : /* @__PURE__ */ o(e, { children: /* @__PURE__ */ o(i, { icon: r.Close, size: m.Medium }) });
}
export {
  c as ModalCloseButton
};
